// extracted by mini-css-extract-plugin
export default {"account__wrap":"DraftAct_account__wrap__m1alD","account__container":"DraftAct_account__container__vxJsK","account__stack":"DraftAct_account__stack__cbs2Q"};